import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SupabaseAuthProvider } from './contexts/SupabaseAuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { PayPalProvider } from './contexts/PayPalContext';
import HomePage from './pages/Home/HomePage';
import LoginPage from './pages/Auth/LoginPage';
import MatchesPage from './pages/Matches/MatchesPage';
import ChatListPage from './pages/Chat/ChatListPage';
import ChatPage from './pages/Chat/ChatPage';
import ProfilePage from './pages/Profile/ProfilePage';
import SettingsPage from './pages/Settings/SettingsPage';
import PrivacySecurityPage from './pages/Settings/PrivacySecurityPage';
import NotificationsPage from './pages/Settings/NotificationsPage';
import LanguagePage from './pages/Settings/LanguagePage';
import HelpSupportPage from './pages/Settings/HelpSupportPage';
import PrivacyPolicyPage from './pages/Legal/PrivacyPolicyPage';
import TermsOfServicePage from './pages/Legal/TermsOfServicePage';
import PremiumPage from './pages/Premium/PremiumPage';
import PaymentPage from './pages/Payment/PaymentPage';
import PaymentMethodsPage from './pages/Payment/PaymentMethodsPage';
import AddPaymentMethodPage from './pages/Payment/AddPaymentMethodPage';
import TransactionHistoryPage from './pages/Payment/TransactionHistoryPage';
import SendMoneyPage from './pages/Payment/SendMoneyPage';
import DatabaseStatusPage from './pages/Admin/DatabaseStatusPage';
import PiAppPage from './pages/PiApp/PiAppPage';
import './index.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <SupabaseAuthProvider>
          <NotificationProvider>
            <PayPalProvider>
              <Router>
              <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 dark:from-gray-900 dark:via-purple-900 dark:to-gray-800 transition-colors duration-300">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/matches" element={<MatchesPage />} />
                  <Route path="/chat" element={<ChatListPage />} />
                  <Route path="/chat/:id" element={<ChatPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/settings/privacy-security" element={<PrivacySecurityPage />} />
                  <Route path="/settings/notifications" element={<NotificationsPage />} />
                  <Route path="/settings/language" element={<LanguagePage />} />
                  <Route path="/settings/help-support" element={<HelpSupportPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                  <Route path="/premium" element={<PremiumPage />} />
                  <Route path="/payment" element={<PaymentPage />} />
                  <Route path="/payment-methods" element={<PaymentMethodsPage />} />
                  <Route path="/payment-methods/add/:type" element={<AddPaymentMethodPage />} />
                  <Route path="/payment-methods/transactions" element={<TransactionHistoryPage />} />
                  <Route path="/payment-methods/send" element={<SendMoneyPage />} />
                  <Route path="/admin/database" element={<DatabaseStatusPage />} />
                  <Route path="/pi-app" element={<PiAppPage />} />
                </Routes>
              </div>
              </Router>
            </PayPalProvider>
          </NotificationProvider>
        </SupabaseAuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;